import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-940aeef0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  ref: "topPane",
  class: "top-pane"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoardPane = _resolveComponent("BoardPane")!
  const _component_RecordPane = _resolveComponent("RecordPane")!
  const _component_TabPane = _resolveComponent("TabPane")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BoardPane, {
          class: "top-left-pane",
          "max-size": _ctx.boardPaneMaxSize
        }, null, 8, ["max-size"]),
        _createVNode(_component_RecordPane, { class: "top-right-pane" })
      ], 512),
      _createVNode(_component_TabPane, {
        class: "bottom-pane",
        size: _ctx.bottomPaneSize
      }, null, 8, ["size"])
    ])
  ]))
}